import { KpiActions, KpiActionTypes } from '../actions/kpi.actions';

/**
 * OrdersState
 */
export interface KpiState {
  loaded: boolean;
  pending: boolean;
  error: any;
  kpi: any;
  currentLocation: any;
}

/**
 * ORDERS_INITIAL_STATE
 * @type {{loaded: boolean; pending: boolean; error: null; orders: any[]; ordersOpen: any[]; ordersDelayed: any[]; ordersAttn: any[]; ordersCompleted: any[]}}
 */
export const KPI_INITIAL_STATE: KpiState = {
  loaded: false,
  pending: false,
  error: null,
  kpi: null,
  currentLocation: null,
};

/**
 * ordersReducer
 * @param {OrdersState} state
 * @param {OrdersActions} action
 * @returns {OrdersState}
 */
export const kpiReducer = (state: KpiState = KPI_INITIAL_STATE, action: KpiActions): KpiState => {
  switch (action.type) {
    case KpiActionTypes.LOAD_KPI:
      return {
        ...state,
        error: null,
        loaded: false,
        pending: true,
      };
    case KpiActionTypes.LOAD_KPI_SUCCESS:
      return {
        ...state,
        loaded: true,
        pending: false,
        kpi: action.payload,
      };
    case KpiActionTypes.LOAD_KPI_ERROR:
      return {
        ...state,
        loaded: false,
        pending: true,
        error: action.payload,
      };
    case KpiActionTypes.SAVE_LOCATION:
      return {
        ...state,
        currentLocation: action.payload,
      };
    default:
      return state;
  }
};
